export const processError = (error) => {
  if (!error) {
    return
  }
  if (error && window.navigator.onLine === false) {
    return {
      data: {
        name: 'Offline',
        message: 'You seem to be offline, check your connection.',
        type: 'offline_error'
      }
    }
  }
  if (error.response) {
    return error.response
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.warn('Request', error.request)

    return {
      data: {
        name: 'Network Error',
        message: 'FoodMesh is not accessible at this time. Please try again later.',
        type: 'network_error'
      }
    }
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error('Error', error.message)
    return {
      data: {
        message:
          error.message || 'FoodMesh is not accessible at this time. Please try again later.',
        type: 'unknown_error'
      }
    }
  }
}
export const normalizeResponseData = (data) => {
  const badKeys = { Message: 'message' } // coming from APPSHEET
  let normalizedData = {}

  if (data) {
    Object.keys(data).forEach((key) => {
      const newKey = badKeys[key] ? badKeys[key] : key
      normalizedData[newKey] = data[key]
    })
    return normalizedData
  }
  return null
}
